import * as R from 'ramda';
import {
  ImageSize,
  ImageType,
  ProductImageDetails,
  ProductType
} from '@inter-ikea-storageone/range';
import { isMobile } from 'utils/platform';
import { IProductImage } from '@inter-ikea-kompis/types';
import { ImageTypeNameEnum } from '@inter-ikea-kompis/enums';

const sizeMap = new Map<ImageSize, number>([
  ['S1', 40],
  ['S2', 110],
  ['S3', 250],
  ['S4', 500],
  ['S5', 2000]
]);

// Product pictures are always square
const sizeToDimension = (size: ImageSize) => sizeMap.get(size);

const transformSources = R.applySpec({
  src: R.prop('url'),
  width: R.pipe(R.prop('size'), sizeToDimension),
  height: R.pipe(R.prop('size'), sizeToDimension)
});

const toImage = R.applySpec<ProductImageDetails>({
  // @ts-ignore
  id: R.pipe(R.head, R.prop('sortNo')),
  // @ts-ignore
  type: R.pipe(R.head, R.prop('typeName')),
  sources: R.map(transformSources)
});

const hasImages = (images: any) => images !== null;

const filterImages = R.filter(
  (image: IProductImage) => image.typeName !== ImageTypeNameEnum.measurementIllustration
);

const getMetaImageSize = (productType: ProductType) =>
  (productType === ProductType.PAX_INTERIOR_SUGGESTIONS ||
    productType === ProductType.PLATSA_INTERIOR_SUGGESTION) &&
  !isMobile()
    ? { width: 100, height: 150 }
    : { width: 100, height: 100 };

export const transformImages: (images: IProductImage[]) => ProductImageDetails[] = R.ifElse(
  hasImages,
  R.pipe<
    IProductImage[],
    IProductImage[],
    { [index: string]: IProductImage[] },
    IProductImage[][],
    ProductImageDetails[]
  >(
    filterImages,
    R.groupBy(image => image.sortNo.toString()),
    R.values,
    R.map(toImage)
  ),
  () => []
);

export const getImageFromMeta = (
  imageName: string,
  imagePath: string,
  productType: ProductType
): ProductImageDetails[] => {
  const size = getMetaImageSize(productType);
  return [
    {
      id: '1',
      type: ImageType.MPP,
      sources: [
        {
          src: `${imagePath}${imageName}`,
          width: size.width,
          height: size.height
        }
      ]
    }
  ];
};
